import { render, staticRenderFns } from "./MidiaTextoHorizontalFullscreen.vue?vue&type=template&id=2620c596&scoped=true"
import script from "./MidiaTextoHorizontalFullscreen.vue?vue&type=script&lang=js"
export * from "./MidiaTextoHorizontalFullscreen.vue?vue&type=script&lang=js"
import style0 from "./MidiaTextoHorizontalFullscreen.vue?vue&type=style&index=0&id=2620c596&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2620c596",
  null
  
)

export default component.exports